import {setting} from '@/setting/index.js'
import { ROUTE_START_RED, ROUTE_END_RED, ROUTE_START_BK, ROUTE_END_BK
    , ROUTE_START_RED_BG, ROUTE_END_RED_BG, ROUTE_START_BK_BG, ROUTE_END_BK_BG
    , ROUTE_ARROW,ROUTE_MARKER
    , SPINNER } from '@/asset';
const file_server_path = setting.url.resource;

const type = {
    icon: "icon/",
    script: "script/",
    ssl: "ssl/"
};

const getUrl = (item) => {
    switch (item) {
        case type.icon: return file_server_path + item;
        case type.script: return file_server_path + item;
        case type.ssl: return  file_server_path + item;
        default: break;
    }
};

const ca = getUrl(type.script) + "cacert.pem";
const cert = getUrl(type.script) + "cert.pem";
const key = getUrl(type.script) + "key.pem";

const lock = getUrl(type.icon) + "lock-icon.png";

const driving = getUrl(type.icon) + "driving.png";
const reserved = getUrl(type.icon) + "book.png";
const send = getUrl(type.icon) + "send.png";
const chatting = getUrl(type.icon) + "chatting.png";
const yellowBell = getUrl(type.icon) + "yellowBell.png";
const document = getUrl(type.icon) + "document.png";

const spinner = SPINNER;

const routeStartRed = ROUTE_START_RED
const routeEndRed = ROUTE_END_RED
const routeStartBk = ROUTE_START_BK
const routeEndBk = ROUTE_END_BK
const routeStartRedBg = ROUTE_START_RED_BG
const routeEndRedBg = ROUTE_END_RED_BG
const routeStartBkBg = ROUTE_START_BK_BG
const routeEndBkBg = ROUTE_END_BK_BG
const routeArrow = ROUTE_ARROW
const routeMarker = ROUTE_MARKER

export {
    ca, cert, key,
    lock,
    driving, reserved,
    send, chatting, yellowBell,
    document, spinner,
    routeStartRed,
    routeEndRed,
    routeStartBk,
    routeEndBk,
    routeStartRedBg,
    routeEndRedBg,
    routeStartBkBg,
    routeEndBkBg,
    routeArrow,
    routeMarker
};